var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_2420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.274 12.3079L6.65175 10.3592C6.60972 10.3363 6.56005 10.3363 6.51802 10.3592L2.86141 12.2391C2.75443 12.2926 2.63216 12.2009 2.65126 12.0862L3.38487 8.03991C3.39252 7.99405 3.37723 7.94438 3.34285 7.90999L0.423674 5.00993C0.339614 4.92587 0.385465 4.78067 0.507734 4.76539L4.58464 4.21136C4.63049 4.20372 4.67252 4.17697 4.69545 4.13494L6.54858 0.463051C6.60208 0.356066 6.75491 0.356066 6.80841 0.463051L8.59277 4.16933C8.61187 4.21136 8.6539 4.24193 8.69975 4.24957L12.7652 4.88002C12.8836 4.89912 12.9295 5.04432 12.8416 5.12838L9.86895 7.97113C9.83456 8.00552 9.81928 8.05137 9.82692 8.09722L10.4841 12.1588C10.5032 12.2773 10.3771 12.3652 10.274 12.3079Z",
    stroke: "#183243",
    strokeWidth: 0.764181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_2420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.27,
    height: 12.7083,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/VectorIcon.aba2dd82db0e607cc9b40966a30dec11.svg";
export { ForwardRef as ReactComponent };